export function toEmbeddedImageDataUrl(value: string | undefined): string | null
{
    if (!value) return null;
    if (value.startsWith("data:")) return value;

    const match = value.match(/^([\w.+/-]+)[;,]base64,(.+)$/s);
    return match ? `data:${match[1]};base64,${match[2]}` : null;
}
